import { RawShaderMaterial, GLSL3 } from "three";
export class CustomShaderMaterial extends RawShaderMaterial {
    constructor(params) {
        super(params);
        this.glslVersion = GLSL3;
        const defines = stringifyDefines(this.defines);
        this.defines = {};
        this.vertexShader = defines + this.vertexShader;
        this.fragmentShader = defines + this.fragmentShader;
        this.onBeforeCompile = onBeforeCompileCustomShader;
        this.customProgramCacheKey = () => {
            // ToDo return parameter with values;
            return `${this.onBeforeCompile.toString()}`;
        };
    }
}
function stringifyDefines(defines) {
    if (defines === undefined)
        return "";
    const chunks = [];
    for (const name in defines) {
        const value = defines[name];
        if (value === false)
            continue;
        if (value !== true && typeof value !== "string")
            continue;
        chunks.push(`#define ${name} ${value}`);
    }
    return chunks.join("\n") + (chunks.length > 0 ? "\n" : "");
}
function onBeforeCompileCustomShader(shader, renderer) {
    let prefixVertex = "";
    let prefixFragment = "";
    let vertexShader = shader.vertexShader;
    let fragmentShader = shader.fragmentShader;
    const currentRenderTarget = renderer.getRenderTarget();
    const numMultiviewViews = currentRenderTarget && (currentRenderTarget.isWebGLMultiviewRenderTarget ? currentRenderTarget.numViews : 0);
    if (renderer.capabilities.isWebGL2) {
        prefixVertex =
            [
                "#define WEBGL_2",
                ...(numMultiviewViews > 0
                    ? ["#extension GL_OVR_multiview2 : require", `layout(num_views = ${numMultiviewViews}) in;`, "#define VIEW_ID gl_ViewID_OVR"]
                    : []),
                "#define attribute in",
                "#define varying out",
                "#define texture2D texture"
            ].join("\n") +
                "\n" +
                prefixVertex;
        prefixFragment =
            [
                "#define WEBGL_2",
                ...(numMultiviewViews > 0 ? ["#extension GL_OVR_multiview2 : require", "#define VIEW_ID gl_ViewID_OVR"] : []),
                "#define varying in",
                "out highp vec4 pc_fragColor;",
                "#define gl_FragColor pc_fragColor",
                "#define gl_FragDepthEXT gl_FragDepth",
                "#define texture2D texture",
                "#define textureCube texture",
                "#define texture2DProj textureProj",
                "#define texture2DLodEXT textureLod",
                "#define texture2DProjLodEXT textureProjLod",
                "#define textureCubeLodEXT textureLod",
                "#define texture2DGradEXT textureGrad",
                "#define texture2DProjGradEXT textureProjGrad",
                "#define textureCubeGradEXT textureGrad"
            ].join("\n") +
                "\n" +
                prefixFragment;
    }
    if (numMultiviewViews > 0) {
        vertexShader = makeShaderMultiviewCompartible(vertexShader, numMultiviewViews);
        fragmentShader = makeShaderMultiviewCompartible(fragmentShader, numMultiviewViews);
    }
    shader.vertexShader = prefixVertex + vertexShader;
    shader.fragmentShader = prefixFragment + fragmentShader;
}
export function makeShaderMultiviewCompartible(shaderSrc, numMultiviewViews) {
    shaderSrc = shaderSrc.replace("uniform mat4 modelViewMatrix;", `uniform mat4 modelViewMatrices[${numMultiviewViews}];\n#define modelViewMatrix modelViewMatrices[VIEW_ID]`);
    shaderSrc = shaderSrc.replace("uniform mat4 projectionMatrix;", `uniform mat4 projectionMatrices[${numMultiviewViews}];\n#define projectionMatrix projectionMatrices[VIEW_ID]`);
    shaderSrc = shaderSrc.replace("uniform mat4 viewMatrix;", `uniform mat4 viewMatrices[${numMultiviewViews}];\n#define viewMatrix viewMatrices[VIEW_ID]`);
    shaderSrc = shaderSrc.replace("uniform mat3 normalMatrix;", `uniform mat3 normalMatrices[${numMultiviewViews}];\n#define normalMatrix normalMatrices[VIEW_ID]`);
    return shaderSrc;
}
